module.exports = __webpack_public_path__ + "img/9.aae37f6a.png";